export default class Endpoints {
  public static participantCsvDetail(id: string) {
    return `convocation/participant-csv/${id}`;
  }
  public static clientCsvDetail(id: string) {
    return `convocation/client-csv/${id}/`;
  }

  public static participantImport = "convocation/participant/import/csv/";
  public static clientImport = "convocation/client/import/csv/";
  public static convocation = "convocation/convocation/";
  public static participant = "convocation/participant/";
  public static paymentStatus = "convocation/payment-status/";
  public static login = "auth/login/";
  // public static tag = "tag/tag/?type=Participant";
  // public static clientTag = "tag/tag/?type=Client";
  public static purchaseTag = "tag/tag/?type=Purchase&is_active=True";
  public static tlp = 'tlp/tlp/?isDefault=True';
  public static country = 'province/country/?is_active=True';
  public static province = 'province/province/?is_active=True';
  public static postalCode = 'province/postalcode';
  public static tag = 'tag/tag/?type=Participant&is_active=True';
  public static clientTag = 'tag/tag/?type=Client&is_active=True';
  //   public static purchaseTag = "tag/tag/?type=Client";
  public static profile = "users/profile/";
  public static client = "users/client/";
  public static clients = "users/clients/";
  public static employee = "users/employee/";
  public static sync = "sync/operation/";
  public static delegation = "general/delegation/";
  public static location = "general/location/";
  public static product = "product/product/";
  public static bonus = "product/has-bonus/";
  public static purchase = "purchase/purchase/";
  public static syncFile = "sync/operation/datafile/";
  public static companion = "purchase/companion/";
  public static procedency = "users/client/procedency/";
  public static emailInUse = "users/is-email-in-use/";
  public static purchaseConvocation = "purchase/purchase/convocation/";
  public static purchaseConvocationCounters = "purchase/purchase/convocation-counters/";
  public static moneyFlows = "purchase/money-flow/";
  public static budget = "purchase/budget/";
  public static remittance = "purchase/budget/remittance/";
  public static bank = "payment/bank/";
  public static bill = "bill/bill/";
  public static internalBusiness = "bussiness/internalbussiness/";
  public static provider = "bussiness/provider/";
  public static user_permissions = "/get_user_permissions/";
  public static client_payment = "users/client-payment/";
  public static client_payment_detail = "users/client-payment-detail/";

  public static convocationInscription(convocationId: string): string {
    return `convocation/convocation/${convocationId}/participant/inscription/`;
  }

  public static purchaseDocument(purchaseId: string): string {
    return `${
      process.env.VUE_APP_BASE_URI_API
    }purchase/purchase/${purchaseId}/document/`;
  }

  public static purchaseDocumentSend(idPurchase: string): string {
    return `/${Endpoints.purchase}${idPurchase}/document/send/`;
  }

  public static purchaseSendAllBill(idConvocation: string): string {
    return `${Endpoints.purchase}document/${idConvocation}/send/all/`;
  }

  public static billDocument(billId: string): string {
    return `${process.env.VUE_APP_BASE_URI_API}bill/bill/${billId}/document/`;
  }

  public static budgetDocument(budgetId: string): string {
    return `${
      process.env.VUE_APP_BASE_URI_API
    }purchase/budget/${budgetId}/document/`;
  }

  public static acquiredCourses(clientId: string): string {
    return `users/client/${clientId}/acquired-courses/`;
  }

  public static budgetParticipantList(budgetId: string): string {
    return `/purchase/budget/${budgetId}/participant/`;
  }

  public static remittanceDocument(remittanceId: string): string {
    return `${
      process.env.VUE_APP_BASE_URI_API
    }purchase/budget/remittance/${remittanceId}/document/`;
  }

  public static budgetValidation(budgetId: string): string {
    return `/purchase/budget/${budgetId}/validation/`;
  }

  public static budgetAcceptanceSend(budgetId: string): string {
    return `/purchase/budget/${budgetId}/acceptance/send/`;
  }

  public static budgetAcceptanceList = '/purchase/budget/acceptance/list/';

  public static budgetValidationSend(budgetId: string): string {
    return `/purchase/budget/${budgetId}/validation/send/`;
  }

  public static budgetDocumentSend(budgetId: string): string {
    return `/purchase/budget/${budgetId}/document/send/`;
  }

  public static budgetMandateAuth(budgetId: string): string {
    return `/purchase/budget/${budgetId}/mandate-auth/`;
  }

  public static budgetMandateSign(budgetId: string): string {
    return `/purchase/budget/${budgetId}/mandate-sign/`;
  }

  public static budgetMandateSignStatus(budgetId: string): string {
    return `/purchase/budget/${budgetId}/mandate/sign-status/`;
  }

  public static mandateDocument(budgetId: string): string {
    return `${
      process.env.VUE_APP_BASE_URI_API
    }purchase/budget/${budgetId}/mandate-document/`;
  }

  public static billUploadDocument(billId: string): string {
    return `/${this.bill}${billId}/document/`;
  }

  public static billDocumentSend(billId: string): string {
    return `/${Endpoints.bill}${billId}/document/send/`;
  }

  public static billChangeDataSend(billId: string): string {
    return `/${Endpoints.bill}${billId}/changeData/send/`;
  }

  public static notificationsNoteSend(data: string): string {
    return `/users/employee/notifications/send/`;
  }

  public static billRefund(billId: string): string {
    return `/${Endpoints.bill}${billId}/refund/`;
  }
  public static billChangeDataExpiration(billId: string): string {
    return `/${Endpoints.bill}${billId}/cambio-datos-set-expiration/`;
  }
  public static purchaseParticipant(purchaseId: string): string {
    return `/${Endpoints.purchase}${purchaseId}/participant/`;
  }

  public static billDowndloadCsv(): string {
    return `${process.env.VUE_APP_BASE_URI_API}${Endpoints.bill}csv/`;
  }

  public static billDowndloadBillZip(): string {
    return `${Endpoints.bill}zip/`;
  }

  public static billSendAllBill(): string {
    return `${Endpoints.bill}/document/send/all/`;
  }
  
  public static regenerateBillPdf(): string {
    return `${Endpoints.bill}/regenerate-bill-pdfs/`;
  }

  public static editBillDates(): string {
    return `${Endpoints.bill}/edit-bill-dates/`;
  }

  public static userFiscalData(userId: string): string {
    return `/${Endpoints.client}${userId}/fiscal-data/`;
  }

  // public static userFiscalDataExtension(userId: string, fiscalDataExtensionId: string): string {
  //   return `/${Endpoints.client}${userId}/fiscal-data-extension/${fiscalDataExtensionId}/`;
  // }

  public static searchFiscalDataExtension(): string {
    return `/users/search-fiscal-data-extension/`;
  }

  public static userFiscalDataExtension(userId: string, fiscalDataExtensionId: string): string {
    return `/users/fiscal-data-extension/${fiscalDataExtensionId}/`;
  }

  public static newUserFiscalDataExtension(): string {
    return `/users/fiscal-data-extension/`;
  }
  
  public static fiscalDataList(userId: string): string {
    return `/users/fiscal-data-list/${userId}/`;
  }

  public static convocationKpi(convocationId: string): string {
    return `/${Endpoints.convocation}${convocationId}/kpi/`;
  }

  public static userMoneyFlow(userId: string): string {
    return `/${Endpoints.client}${userId}/moneyflow/`;
  }

  public static rejectBudget(budgetId: string): string {
    return `/${Endpoints.budget}/${budgetId}/acceptance/reject/`;
  }

  public static userPermissions(id: string): string {
    return `/${Endpoints.user_permissions}`;
  }

  public static clientPayment(id: string, viewStatus:number): string {
    return `/${Endpoints.client_payment}${id}/${viewStatus}`;
  }

  public static clientPaymentDetail(id: string, viewStatus:number): string {
    return `/${Endpoints.client_payment_detail}${id}/${viewStatus}`;
  }

  public static newClientPayment(id: string, viewStatus:number): string {
    return `/${Endpoints.client_payment}${id}/${viewStatus}`;
  }
}
